import './LegalPage.css';

/**
 * CGU (Conditions Générales d'Utilisation) Page
 */
export const CGU = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-page__content">
          <h1 className="legal-page__title">Conditions Générales d'Utilisation</h1>
          
          <section className="legal-page__section">
            <h2>Article 1 - Objet</h2>
            <p>
              Les présentes Conditions Générales d'Utilisation (CGU) ont pour objet de définir les modalités
              et conditions d'utilisation du site Bookiner ainsi que les services proposés.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 2 - Acceptation des CGU</h2>
            <p>
              L'accès et l'utilisation du site impliquent l'acceptation pleine et entière des présentes CGU.
              Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le site.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 3 - Inscription</h2>
            <p>
              L'inscription à la liste de démonstration nécessite la fourniture d'informations exactes et à jour.
              Toute information inexacte ou frauduleuse pourra entraîner la suspension ou la suppression du compte.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 4 - Utilisation du service</h2>
            <p>
              Vous vous engagez à utiliser le service de manière conforme à sa destination et dans le respect
              des lois et règlements en vigueur. Toute utilisation abusive ou frauduleuse est interdite.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 5 - Propriété intellectuelle</h2>
            <p>
              Tous les contenus présents sur le site (textes, images, graphismes, logo, icônes, etc.)
              sont la propriété exclusive de Bookiner et sont protégés par le droit d'auteur.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 6 - Responsabilité</h2>
            <p>
              Bookiner ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation du site,
              notamment en cas d'interruption, de dysfonctionnement ou d'erreur dans les informations fournies.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 7 - Modification des CGU</h2>
            <p>
              Bookiner se réserve le droit de modifier les présentes CGU à tout moment.
              Les utilisateurs seront informés de toute modification substantielle.
            </p>
          </section>

          <section className="legal-page__section">
            <h2>Article 8 - Droit applicable</h2>
            <p>
              Les présentes CGU sont régies par le droit français. En cas de litige,
              les tribunaux français seront seuls compétents.
            </p>
          </section>

          <a href="/" className="legal-page__back">← Retour à l'accueil</a>
        </div>
      </div>
    </div>
  );
};

export default CGU;
